import { useSelector } from 'react-redux';

import Form from 'app/components/Form';

import {
  createOption,
  localeOptions
} from 'app/utils/options';

const MemberForm = props => {
  const {
    member,
    onClose,
    onSubmit,
    action,
    account
  } = props;

  const user = useSelector(state => state.userReducer.user);

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const roleOptions = [
    createOption('Standard User (non-admin)', 0),
    createOption('Photographer (isolated account)', 2),
    createOption('Admin (full access)', 1),
  ];

  let fields = [
    { name: 'name', label: 'Name', type: 'text', value: member?.name },
    { name: 'email', label: 'Email', type: 'email', value: member?.email },
    { name: 'phone', label: 'Phone', type: 'tel', value: member?.phone },
    { name: 'role', label: 'Role', type: 'select', value: member?.role, valueType: 'integer', options: roleOptions, hideNoneOption: true },
    { name: 'pin', label: 'Pin', type: 'text', value: member?.pin },
  ]

  // if (account.feature_flags.kiosk_mode) {
  //   fields.push({ name: 'pin', label: 'Pin', type: 'text', value: member?.pin });
  // }

  fields = fields.concat([
    { name: 'new_password', label: 'New Password', type: 'password', value: member?.new_password },
    { name: 'password_confirmation', label: 'Confirm Password', type: 'password', value: member?.password_confirmation },
    { name: 'locale', label: 'Language', type: 'select', value: member?.locale || user.locale, valueType: 'string', options: localeOptions, hideNoneOption: true }
  ]);

  // use default label if updating member
  let submitButtonLabel = null;

  if (action === 'create') {
    fields.push({ name: 'message', label: 'Optional message', type: 'textarea' });

    submitButtonLabel = 'Send Invite';
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit,
      submitButtonLabel
    }} />
  );
}

export default MemberForm;
